// extracted by mini-css-extract-plugin
export default {"scoreboard":"Scoreboard_scoreboard__yBYXn","tabContent":"Scoreboard_tabContent__zmQ-n"};